import { computed } from 'vue'
import { useConfig } from './use-config'

interface BaseProps {
  href?: string
  to?: string
  tag?: string
}

export const useButton = (props: BaseProps) => {
  const { config } = useConfig()

  const args = computed(() => {
    const result: Record<string, string | undefined> = {
      is: props.tag
    }

    if (props.href) {
      result.is = 'a'
      result.href = props.href
      result.target = '_blank'
      result.rel = 'noopener'
    } else if (props.to) {
      result.is = 'router-link'
      result.to = config.value.normalizePath(props.to, {
        locale: config.value.locale
      })
    }

    if (result.is === 'button') {
      result.type = 'button'
    }

    return result
  })

  const bindings = computed(() => {
    const { is, ...result } = args.value

    return result
  })

  return { args, bindings }
}
